<template>
  <ViewEntityContainer :entityName="entityName" :identifier="$route.params.customerGroupId"
    :getMethod="getCustomerGroupById" :refreshOnTimestamp="true" :notificationListeners="[srEventKey]"
    :notificationValidator="notificationValidator">
  </ViewEntityContainer>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SRConst from "@/helpers/Constants/SignalRConstants.js";
import ViewEntityContainer from "@/views/pim/suppliers/ViewEntityContainer.vue";
import EntityNames from "@/helpers/Constants/EntityNames.js";

export default {
  name: "ViewCustomerGroupContainer",
  components: {
    ViewEntityContainer,
  },
  mixins: [clientAPI],

  data() {
    return {
      entityName: EntityNames.CustomerGroup
    };
  },

  methods: {
    notificationValidator(args, identifier) {
      return args && args.customerGroupId == identifier;
    },
  },

  computed: {
    srEventKey() {
      return SRConst.EventKeys.CustomerGroupChange;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>